export const createUrl = <T extends Record<string, string | undefined>>(path: string, params: T) => {
	const url = new URL(path, window.location.origin);

	Object.entries(params).forEach(([key, value]) => {
		if (value !== undefined) {
			url.searchParams.append(key, value);
		}
	});

	return `${url.pathname}${url.search}`;
};
